import { lazy } from "react";
import { ScreenLoader } from "../utils/ScreenLoader";
import { AuthGuard } from "../utils/AuthGuard";
import { RoleGuard } from "../contexts/RoleGuard";

const Dashboard = ScreenLoader(lazy(() => import("../screens/Dashboard")));

//maping the dashboard route completely
export const DashboardRoute = () => ({
  path: "dashboard",
  element: (
    <AuthGuard>
      <RoleGuard requiredPermission="dashboard" requiredActions={["isRead"]}>
        <Dashboard />
      </RoleGuard>
    </AuthGuard>
  ),
});
